import { Typography } from '@/components/common';
import { Metrics } from '@/interfaces';
import clsx from 'clsx';
import * as React from 'react';

export interface DonutsBicolorProps {
	metricsArray: Metrics[];
	size: number; // Optional size with default value
	strokeWidth: number; // Border thickness
	classNameContainer?: string;
}

export const DonutBicolorChart: React.FC<DonutsBicolorProps> = ({
	metricsArray,
	size,
	strokeWidth,
	classNameContainer,
}) => {
	const firstValue = metricsArray[0];
	const secondValue = metricsArray[1];

	const radius = (size - strokeWidth) / 2;
	const circumference = 2 * Math.PI * radius; // Total length of the circle
	const yesOffset = circumference * (1 - firstValue.percentage / 100);

	return (
		<div
			className={clsx('flex gap-2 w-full justify-center', classNameContainer)}
		>
			<LeyendaItem
				color={secondValue.color}
				percentage={secondValue.percentage}
				title={secondValue.title}
				isSecondValue
			/>
			{/* SVG Donut Chart */}
			<svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
				{/* Second Value */}
				<circle
					cx={size / 2}
					cy={size / 2}
					r={radius}
					strokeWidth={strokeWidth}
					stroke={secondValue.color}
					fill="transparent"
				/>
				{/* First Value */}
				<circle
					cx={size / 2}
					cy={size / 2}
					r={radius}
					strokeWidth={strokeWidth}
					stroke={firstValue.color}
					fill="transparent"
					strokeDasharray={circumference}
					strokeDashoffset={yesOffset}
					transform={`rotate(-90 ${size / 2} ${size / 2})`}
					strokeLinecap="round"
				/>
			</svg>
			<LeyendaItem
				color={firstValue.color}
				percentage={firstValue.percentage}
				title={firstValue.title}
			/>
		</div>
	);
};

export const LeyendaItem: React.FC<Metrics & { isSecondValue?: boolean }> = ({
	color,
	percentage,
	title,
	isSecondValue,
}) => {
	return (
		<div
			className={clsx('flex', {
				'items-end ': isSecondValue,
				'items-start ': !isSecondValue,
			})}
		>
			<div
				className={clsx('flex gap-2 mt-2 items-center', {
					'flex-row-reverse mb-2': isSecondValue,
				})}
			>
				<span
					style={{ backgroundColor: color }}
					className="w-4 h-4 min-w-4 min-h-4 rounded-full"
				></span>
				<Typography
					type="semibold-16"
					style={{ color: isSecondValue ? '#6E6A73' : color }}
				>
					{title}: {percentage}%
				</Typography>
			</div>
		</div>
	);
};
